<template>
  <div v-if="page" :class="['page']">
    <h2 v-html="page.title" :class="['headline']" />
    <p v-html="page.description" :class="['body-1', 'my-4']" />
  </div>
</template>
<script>
import methods from '../mixins/methods'

export default {
  name: 'Page',
  mixins: [
    methods
  ],
  data () {
    return {
      page: null
    }
  },
  mounted () {
    this.onMounted()
  },
  watch: {
    '$route.path' () {
      this.getPage()
    }
  },
  methods: {
    /**
     * Handler for the $mounted event of the component
     * @method onMounted
     * @return {void}
     */
    onMounted () {
      this.getPage()
    },
    /**
     * Get the page meta data and content
     * @method getPage
     * @return {void}
     */
    getPage () {
      const route = this.$api[this.$route.name]
      const url = `/static/pages${route.meta}.json`
      this.$http({
        url,
        method: route.methods[0]
      }).then(response => {
        if (response.data) {
          this.page = response.data
          this.setDocumentTitle(this.page.title)
          document.querySelector('meta[name="description"]').setAttribute('content', this.page.description)
          document.querySelector('meta[name="keywords"]').setAttribute('content', this.page.keywords.join(', '))
        }
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page.vue